import {Action, ActionReducer} from '@ngrx/store';
import {CurrentUserDetailsModel, UserUploadsDetailsModel} from '../../../shared/models/users/users.models';
import {CURRENT_USER_STORAGE_KEY} from '../../../core/constants/local-storage-keys.constansts';
import { CurrentUserActions } from '../../actions/user/current-user.actions';

interface IUserAction extends Action {
  data: (CurrentUserDetailsModel | UserUploadsDetailsModel[]);
}

export function currentUserMetaReducer<STATE, ACTION extends IUserAction = IUserAction>(reducer: ActionReducer<STATE, ACTION>):
  ActionReducer<STATE, ACTION> {
  return (state: STATE, action: ACTION) => {

    if (action.type === CurrentUserActions.loadCurrentUserSuccess.type) {
      const userData = action?.data ? action.data : null;
      localStorage.setItem(CURRENT_USER_STORAGE_KEY, JSON.stringify(userData));
    }

    if (action.type === CurrentUserActions.loadAmplifyUserSuccess.type) {
      const userData = action?.data ? action.data : null;
      localStorage.setItem(CURRENT_USER_STORAGE_KEY, JSON.stringify(userData));
    }

    if (action.type === CurrentUserActions.clearCurrentUserDetails.type) {
      localStorage.removeItem(CURRENT_USER_STORAGE_KEY);
    }

    if (action.type === CurrentUserActions.loadCurrentUserUploadDetailsSuccess.type) {
      let currentUser = JSON.parse(localStorage.getItem(CURRENT_USER_STORAGE_KEY));
      currentUser = {...currentUser, uploads: action.data};
      localStorage.setItem(CURRENT_USER_STORAGE_KEY, JSON.stringify(currentUser));
    }

    if (action.type === CurrentUserActions.loadCurrentUserPermissionsSuccess.type) {
      let currentUser = JSON.parse(localStorage.getItem(CURRENT_USER_STORAGE_KEY));
      currentUser = {...currentUser, permissions: action.data};
      localStorage.setItem(CURRENT_USER_STORAGE_KEY, JSON.stringify(currentUser));
    }

    if (action.type === CurrentUserActions.loadAmplifyUserPermissionsSuccess.type) {
      let currentUser = JSON.parse(localStorage.getItem(CURRENT_USER_STORAGE_KEY));
      currentUser = {...currentUser, permissions: action.data};
      localStorage.setItem(CURRENT_USER_STORAGE_KEY, JSON.stringify(currentUser));
    }

    return reducer(state, action);
  };
}
